<template>
  <div class="row">
    <div class="well">
      <button class="btn btn-lg btn-primary button" @click="onCreateButtonClick">
        <strong>Add Blocklist Email</strong>
      </button>

      <p class="instructions">No emails will be sent to any address added to the Blocklist. The reasons can be anything you'd like to keep track of why they were added to the Blocklist.</p>
    </div>

    <snappy-table
      ref="table"
      :endpoint="'vessels/' + vesselId + '/blocklist-terms'"
      :columns="['id','term','reason', 'actions']"
      :headings="['ID', 'Email', 'Reason', 'Actions']"
      :templated-slot-names="['actions']"
      :search-order-by="'id'"
      record-type="Blocklist Emails"
    >
      <template #actions="{ row }">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="action-button edit btn btn-info"
            title="Edit"
            v-tooltip="'Edit'"
            @click="onUpdateButtonClick($event, row)">Edit
          </button>
          <button
            type="button"
            class="action-button btn btn-danger"
            title="Delete"
            v-tooltip="'Delete'"
            @click="onDeleteButtonClick($event, row)"
            :disabled="isDeleteSpinning(row.id)">
            {{ isDeleteSpinning(row.id) ? 'Deleting' : 'Delete' }}
            <i v-if="isDeleteSpinning(row.id)" class="fas fa-fw fa-spinner fa-spin"></i>
          </button>
        </div>
      </template>
    </snappy-table>

    <div class="modal fade" id="blocklist-terms-create-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeCreateModal">
              <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="modal-title">Create Blocklist Email</h4>
          </div>

          <div class="modal-body mb-0 p-0">
            <div class="form">
              <div class="form-group">
                <label for="create_term_input" class="col-sm-2 control-label">Email</label>

                <div class="col-sm-10">
                  <input type="text" class="form-control" id="create_term_input" placeholder="Email" v-model="currentTerm.term"/>
                </div>
              </div>

              <div class="form-group">
                <label for="create_reason_input" class="col-sm-2 control-label">Reason</label>

                <div class="col-sm-10">
                  <input type="text" class="form-control" id="create_reason_input" placeholder="Reason" v-model="currentTerm.reason"/>
                </div>
              </div>

              <button class="action-button btn btn-primary btn-lg" @click="create" :disabled="createSpinner">
                {{ this.createSpinner ? 'Creating' : 'Create' }} <i v-if="createSpinner" class="fas fa-fw fa-spinner fa-spin"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="blocklist-terms-update-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeUpdateModal">
              <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="modal-title">Edit Blocklist Email</h4>
          </div>

          <div class="modal-body mb-0 p-0">
            <div class="form">
              <div class="form-group">
                <label for="update_term_input" class="col-sm-2 control-label">Email</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="update_term_input" placeholder="Email" v-model="currentTerm.term"/>
                </div>
              </div>

              <div class="form-group">
                <label for="update_reason_input" class="col-sm-2 control-label">Reason</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="update_reason_input" placeholder="Reason"
                         v-model="currentTerm.reason"/>
                </div>
              </div>

              <button class="action-button btn btn-primary btn-lg" @click="update" :disabled="createSpinner">
                {{ this.updateSpinner ? 'Updating' : 'Update' }} <i v-if="updateSpinner" class="fas fa-fw fa-spinner fa-spin"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SnappyTable from '../components/SnappyTable';
import swal from "sweetalert2";

export default {
  name: 'account-blocklist-terms-page',
  components: {SnappyTable},
  props: {
    vesselId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      spinningDeleteBtnIds: [],
      updateSpinner: false,
      createSpinner: false,
      currentTerm: {
        id: '',
        term: '',
        reason: '',
      }
    }
  },
  methods: {
    onDeleteButtonClick(event, blocklist_term) {
      let self = this;
      self.addDeleteSpinner(blocklist_term.id);

      axios.post('/api/?entity=blocklist-emails&action=delete&blocklistTermId=' + blocklist_term.id)
        .then((result) => {
          if (result.status === 204) {

            self.removeDeleteSpinner(blocklist_term.id);
            self.refresh();
          } else {
            self.showError();

            self.removeDeleteSpinner(blocklist_term.id);
            self.refresh();
          }
        });
    },

    onUpdateButtonClick(event, blocklist_term) {
      this.currentTerm.term = blocklist_term.term;
      this.currentTerm.reason = blocklist_term.reason;
      this.currentTerm.id = blocklist_term.id;

      this.openUpdateModal();
    },

    onCreateButtonClick() {
      this.clearCurrentTerm();

      this.openCreateModal();
    },

    openCreateModal() {
      $('#blocklist-terms-create-modal').modal('show');
    },

    closeCreateModal() {
      $('#blocklist-terms-create-modal').modal('hide');
    },

    openUpdateModal() {
      $('#blocklist-terms-update-modal').modal('show');
    },

    closeUpdateModal() {
      $('#blocklist-terms-update-modal').modal('hide');
    },

    update() {
      let self = this;

      let data = {
        term: self.currentTerm.term,
        reason: self.currentTerm.reason,
      };

      self.updateSpinner = true;

      axios.post('/api/?entity=blocklist-emails&action=update&blocklistTermId=' + self.currentTerm.id, data)
        .then((result) => {
          self.updateSpinner = false;
          self.closeUpdateModal();
          self.refresh();
        })
        .catch((error) => {
          self.updateSpinner = false;
          self.showError(error.response.data.message);
        });
    },

    create(event) {
      let self = this;

      let data = {
        term: self.currentTerm.term,
        reason: self.currentTerm.reason,
      };

      self.createSpinner = true;

      axios.post('/api/?entity=blocklist-emails&action=create', data)
        .then((result) => {
          self.createSpinner = false;
          self.closeCreateModal();
          self.refresh();
        })
        .catch((error) => {
          self.createSpinner = false;
          self.showError(error.response.data.message);
        });
    },

    isDeleteSpinning(value) {
      return this.spinningDeleteBtnIds.includes(value);
    },

    addDeleteSpinner(value) {
      this.spinningDeleteBtnIds.push(value);
    },

    removeDeleteSpinner(value) {
      this.spinningDeleteBtnIds.splice(this.spinningDeleteBtnIds.indexOf(value), 1);
    },

    refresh() {
      this.$refs.table.refresh();
    },

    clearCurrentTerm() {
      this.currentTerm = {
        id: '',
        term: '',
        reason: '',
      };
    },

    showError(message) {
      let options = {
        title: 'UhOh!',
        text: 'Something went wrong.',
        type: 'error',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-primary',
      };

      if (message) {
        options.text = message;
        options.title = 'Validation error';

        swal.fire(options);
      } else {
        swal.fire(options).then(function () {
          this.refresh();
        });
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modal {
  background-color: rgba(#000, 0.5);
}

.close {
  top: 14px;
  right: 20px;
}

.action-button {
  &.edit {
    margin-right: 15px;
  }
}

.form {
  width: 60%;
  position: relative;
  margin: 30px auto;

  > .form-group {
    display: flex;
  }
}

.instructions {
  margin: 1.41575em 0;
}
</style>
